import * as React from "react";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { postJsonData } from "../network/ApiController";
import AuthContext from "../store/AuthContext";

const ClaimCollections2 = ({ refresh, row }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [data, setData] = React.useState("");
  const [request, setRequest] = React.useState(false);

  const authCtx = React.useContext(AuthContext);
  const user = authCtx.user;

  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);

  const handleModalOpen = () => {
    setModalOpen(true);
    checkStatus();
  };
  const handleModalClose = () => {
    setModalOpen(false);
       if(refresh) refresh()
    setData("");
  };

  const checkStatus = () => {
    postJsonData(
      ApiEndpoints.CHECK_STATUS_UPI,
      { id: row.id },
      () => {},
      (res) => {
        const result = res?.data?.data || res?.data?.message || "No message available";
        setData(result);
    
      },
      (err) => {
        okErrorToast(err);
        setData(err?.message || "Something went wrong");
      }
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = {
      id: row.id,
      remark: form.remark.value,
    };
    setRequest(true);
    postJsonData(
      ApiEndpoints.CLAIM,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res.data.message || "Success");
        handleDrawerClose();
        if (refresh) refresh();
      },
      (error) => {
        if (refresh) refresh();
     

        
        apiErrorToast(error);
   
      }
    );
  };

  const isClaimed = row.status === "Claimed";
  const isUnclaimed = row.status === "Unclaimed";
  const isButtonDisabled = isClaimed && user.role === "Admin";

  const handleClick = () => {
    if (isUnclaimed && user.role !== "Admin"||row.status === "success") {
      handleDrawerOpen();
    } else if (row.status === "Pending"||row.status === "scanning") {
      handleModalOpen();
    } else {
    if (user.role === "Admin") {
  // okErrorToast("Admins are not allowed to claim.");
} else {
  // okSuccessToast("Already claimed.");
}

    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      <Tooltip title="Claim">
        <Button
          variant="outlined"
          onClick={handleClick}
          disabled={isButtonDisabled}
          sx={{
            py: 0.8,
            px: 2,
            fontWeight: 500,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "0.875rem",
            color: isClaimed ? "#d93025" : "primary.main",
            borderColor: isClaimed ? "#d93025" : "primary.main",
            backgroundColor: isClaimed ? "#fdecea" : "white",
            "&.Mui-disabled": {
              color: "#d93025",
              borderColor: "#d93025",
              backgroundColor: "#fdecea",
            },
            "&:hover": {
              backgroundColor: isClaimed ? "#fdecea" : "#f5faff",
            },
          }}
        >
          {isClaimed ? "Claimed" : isUnclaimed ||row.status==="success"? "Claim" : "Check Status"}
        </Button>
      </Tooltip>

      {/* Drawer */}
      <Drawer open={drawerOpen} anchor="right" onClose={handleDrawerClose}>
        <Box sx={{ width: 400 }} className="sm_modal">
          <ModalHeader
            title="Claim Collections"
            handleClose={handleDrawerClose}
            subtitle="Simplify Your Workflow: Add New version"
          />
          <Box
            component="form"
            id="addversion"
            onSubmit={handleSubmit}
            sx={{ "& .MuiTextField-root": { m: 1 } }}
          >
            <Grid container sx={{ pt: 1 }}>
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Remark"
                    id="remark"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ mr: "10px" }}>
            <ModalFooter form="addversion" request={request} />
          </Box>
        </Box>
      </Drawer>

      {/* Modal */}
      <Modal open={modalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
            width: 400,
            maxWidth: "90%",
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">UPI Status</Typography>
            <IconButton onClick={handleModalClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box mt={2}>
            {typeof data === "object" ? (
              <Box>
                <Typography><strong>Customer Name:</strong> {data.customer_name}</Typography>
                <Typography><strong>Customer VPA:</strong> {data.customer_vpa}</Typography>
                <Typography><strong>Amount:</strong> ₹{data.amount}</Typography>
                <Typography><strong>Status:</strong> {data.status}</Typography>
                <Typography><strong>Txn ID:</strong> {data.upi_txn_id}</Typography>
              </Box>
            ) : (
              <Typography variant="body1">{data || "Checking..."}</Typography>
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ClaimCollections2;
